//Library imports
import styled from "styled-components";
import { Card, Tag } from "antd";
import { useEffect, useState } from "react";
//Local imports
import { ReactComponent as Audience } from "../../../assets/img/icons/Audience.svg";
import { ReactComponent as OpenEmail } from "../../../assets/img/icons/Open_Email.svg";
import { ReactComponent as Send } from "../../../assets/img/icons/Send (5).svg";
import { ReactComponent as Eye } from "../../../assets/img/icons/eye.svg";
import { ReactComponent as Click } from "../../../assets/img/icons/Click.svg";
import { ReactComponent as Analytics } from "../../../assets/img/icons/nav/analytics.svg";
import { ReactComponent as Flow } from "../../../assets/img/icons/nav/Flow.svg";
import CalendarDiv from "../../Common/CalendarDiv";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { IMAGE_SERVICE_URL } from "../../../constants/index";
import { getQueryCampaignId } from "modules/EmailBrowser/utils";
import store from "store";
import { ALL_ARTICLES_IN_EDITION, DESIGN } from "constants/actionTypes";
import { getEditionArticles } from "../Edition/actions";
import { EMAIL_LIST } from "constants/types";

const EditionCard = (props: any) => {
  const {
    emailType,
    scheduled_time,
    isScheduled = false,
    data,
    sent_date,
    sent_month,
    campaignId,
    showEmailStats,
    scheduledStyle = false,
    automation,
    isWFActionEmail,
    tabState,
  } = props;
  const [date, setDate] = useState("");
  const [month, setMonth] = useState("");
  const history = useHistory();
  const searchURL = history.location.search + "&email_id=" + data.version_id;

  const splitDayMonth = () => {
    const myArr = data.sent_date.split(",")[0].split(" ");
    setMonth(myArr[0].toString());
    setDate(myArr[1].toString());
  };

  useEffect(() => {
    if (data.sent_date !== null) {
      splitDayMonth();
    }
  }, [data.sent_date]);

  return (
    <Style color="#6DD48E">
      <Card bodyStyle={{ width: "100%" }} className={`card-style ${scheduledStyle ? "card-style-scheduled" : ""}`}>
        <DivFlexOuter>
          <DivFlex
            onClick={() => {
              store.dispatch({ type: DESIGN.RESET_DESIGN });
              store.dispatch({ type: ALL_ARTICLES_IN_EDITION.RESET_ALL_DATA });
              getEditionArticles(data.version_id);
              if (isScheduled) {
                history.push(
                  `/campaigns/editionedit/publish/?campaign_id=${getQueryCampaignId()}&email_id=${data.version_id}`
                );
              } else {
                if (emailType.toString() === "1") {
                  history.push("/campaigns/editionedit/publish" + searchURL);
                } else {
                  history.push("/campaigns/editionedit" + searchURL);
                }
              }
            }}
          >
            <CalendarDiv color={`${scheduledStyle ? "Green" : "Grey"}`} date={sent_date} month={sent_month} />

            <div className="color-strip clickable"></div>
            <div className="image-wrapper">
              <img
                className="image-resize clickable"
                alt=""
                src={
                  data.thumbnail[0] ||
                  IMAGE_SERVICE_URL +
                    "/returnimage/?url=&width=95&height=95&articleid=357964118&detectface=true&app_name=wb"
                }
                onError={(e: any) => {
                  e.target.onerror = null;
                  e.target.src =
                    IMAGE_SERVICE_URL +
                    "/returnimage/?url=&width=95&height=95&articleid=357964118&detectface=true&app_name=wb";
                }}
              ></img>
              <div
                className="image-background image-resize clickable"
                style={{
                  backgroundImage: `url(${
                    data.thumbnail[0] ||
                    IMAGE_SERVICE_URL +
                      "/returnimage/?url=&width=95&height=95&articleid=357964118&detectface=true&app_name=wb"
                  })`,
                }}
              >
                {data.is_test ? (
                  <Tag className={`styling-tag test-tag`}>{data.is_test === "Test" ? "Test" : ""}</Tag>
                ) : (
                  <> </>
                )}
              </div>
            </div>
            <div>
              <div className="article-text-style clickable" data-id="name-of-edition">
                {data.name}
              </div>
              {data.sent_by.trim() !== "" && scheduledStyle ? (
                <div className="grey-text ">
                  {`Scheduled by: `}
                  <text className="green-mail-text" data-id="email-of-edition-sender">
                    {data.sent_by}
                  </text>
                </div>
              ) : data?.sent_by ? (
                <div className="grey-text ">
                  {`Sent by: `}
                  <text className="green-mail-text" data-id="email-of-edition-sender">
                    {data.sent_by}
                  </text>
                </div>
              ) : (
                <></>
              )}
              <div className="grey-text ">
                {isScheduled ? `Sends in: ` : ``}
                {isScheduled ? <b>{scheduled_time}</b> : data.sent_date ? `${data.sent_date}` : ""}
              </div>
            </div>
          </DivFlex>
          <div className="display-flex analytics-icon">
            {showEmailStats && (
              <DivFlex className="icon-spacing" data-class="sent-stats-icon">
                <div className="icon-styling">
                  <Audience />
                  <div className="icon-text-styling">{data.total_contacts || 0}</div>
                </div>
                <div className="icon-styling">
                  <Send />
                  <div className="icon-text-styling">{data.total_sent || 0}</div>
                </div>
                <div className="icon-styling">
                  <OpenEmail />
                  <div className="icon-text-styling">{data.total_delivery || 0}</div>
                </div>
                <div className="icon-styling eye">
                  <Eye />
                  <div className="icon-text-styling">{data.total_open || 0}</div>
                </div>
                <div className="icon-styling">
                  <Click />
                  <div className="icon-text-styling">{data.total_clicks || 0}</div>
                </div>
              </DivFlex>
            )}
            {/* <div> */}
            <div>
              {showEmailStats && (
                <Link
                  className={data.status === "Error" || data.status === "Scheduled" ? "disable-link" : ""}
                  to={`/analytics?campaign_id=${campaignId}&email_id=${data.version_id}`}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    localStorage.setItem("analytics_back_url", window.location.pathname + window.location.search);
                    store.dispatch({ type: EMAIL_LIST.SET_TAB_STATE, payload: { tabState: tabState } });
                  }}
                >
                  <span className="analytics-btn">
                    <Analytics />
                  </span>
                </Link>
              )}
            </div>
            {/* </div> */}
            <div className="tags-container">
              {automation && (
                <Link
                  to={`/automation/details?workflow_id=${data?.workflow_id}&from=campaigns&campaign_id=${campaignId}`}
                >
                  <Tag className={`automation-icon styling-tag pending-tag`} color="#DEF6E6">
                    <Flow /> <span>Workflow</span>
                  </Tag>
                </Link>
              )}

              <Tag
                className={`${data.status === "Error" ? "error-tag" : ""} styling-tag pending-tag`}
                color="#DEF6E6"
              >
                {data.status === "Scheduled" ? "Scheduled" : data.status}
              </Tag>
            </div>
          </div>
        </DivFlexOuter>
      </Card>
    </Style>
  );
};

export default EditionCard;

EditionCard.defaultProps = {
  showEmailStats: true,
};

const DivFlex = styled.div`
  display: flex;
  align-items: center;
  .sent-date-title {
    padding-top: 5px;
    padding-left: 10px;
    font-family: "robotoregular", sans-serif;
    font-size: 14px;
    color: #67696a;
  }
`;

const DivFlexOuter = styled.div`
  display: flex;
  justify-content: space-between;
  .icon-spacing {
    margin: 0 1em 0 2em;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin: 0 2px;
    }
  }
  .menu-item-align {
    text-align-last: end;
    margin: 1em 0.45em 0 0;
  }
`;

const Style = styled.div<{ color: string }>`
  margin-bottom: 1em;
  position: relative;
  .clickable {
    cursor: pointer;
  }
  .color-strip {
    margin-left: 1.5em;
    width: 11px;
    height: 94px;
    background-color: ${(props) => props.color};
    border-radius: 5px 0 0 5px;
    border-right: 1px solid #ffffff;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 7px;
      height: 67px;
      border-radius: 4px 0 0 4px;
      margin-left: 17px;
    }
  }
  .display-flex {
    display: flex;
  }
  .analytics-icon {
    > div:nth-child(2) {
      min-width: 30px;
      text-align: right;
    }
  }
  .analytics-btn {
    position: absolute;
    top: 40px;
    right: 20px;
    cursor: pointer;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      top: 45px;
    }
    svg {
      width: 26px;
      height: auto;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 20px;
      }
      path {
        fill: #27ce0a;
      }
    }
  }
  .disable-link {
    pointer-events: none;
    opacity: 0.5;
    /* .analytics-btn {
      opacity: 0.5;
    } */
  }
  .tags-container {
    position: absolute;
    right: 10px;
  }
  .styling-tag {
    margin: 0;
    border-radius: 16px;
    color: #27ce0a;
    vertical-align: middle;
    font-size: 12px;
    font-weight: 700;
    font-family: "robotoregular";
    line-height: 16px;
    margin-top: 0px;
    margin-right: 5px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 9px;
      line-height: 12px;
      border-radius: 10px;
      margin-top: -15px;
    }
    &.pending-tag {
      background-color: #fff !important;
      color: #27ce0a;
    }
    &.test-tag {
      color: #fff;
      background-color: #27ce0a !important;
      border-color: #27ce0a !important;
      margin-left: 5px;
    }
    &.error-tag {
      background-color: #d22121 !important;
      color: #f9f8f6;
    }
    &.automation-icon {
      padding: 3px 6px;
      background-color: #def6e6 !important;
      svg {
        width: 12px;
        height: auto;
        vertical-align: middle;
        g {
          fill: #27ce0a;
        }
      }
    }
  }
  .icon-text-styling {
    color: #5e7079;
    font-size: 12px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: 700;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 9px;
    }
  }
  .icon-styling {
    margin: 0 0.75em;
    text-align: center;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin: 0 8px;
    }
    svg {
      height: 16px;
      width: auto;
      margin: 0 auto;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        height: 10px;
      }
    }
    &.eye {
      svg path {
        fill: #000000;
        opacity: 0.5;
      }
    }
  }
  .article-text-style {
    color: #000000;
    font-size: 20px;
    line-height: 24px;
    height: 50px;
    word-wrap: break-word;
    margin-left: 0.5em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
      line-height: 18px;
      height: 36px;
    }
  }
  .card-style {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f0efef;
    border-radius: 10px;
    height: 105px;
    &.card-style-scheduled {
      background-color: #e1f6e6;
      border: 2px solid #1ec252;
    }
    .ant-card-body {
      padding: 18px 28px;
    }
  }
  .image-wrapper {
    position: relative;
    img {
      z-index: 0;
      position: absolute;
      top: 0;
      left: 0;
    }
    .image-resize {
      width: 115px;
      min-width: 115px;
      height: 94px;
      border-radius: 0 5px 5px 0;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 82px;
        min-width: 82px;
        height: 67px;
        border-radius: 0 4px 4px 0;
      }
      &.image-background {
        background-size: cover;
        background-repeat: no-repeat;
        z-index: 1;
        position: relative;
      }
    }
  }
  .dark-gray-img {
    background: darkgray;
    padding: 15px;
  }
  .grey-text {
    font-family: "Roboto";
    padding-left: 10px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 10px;
    }
    .green-mail-text {
      color: #1ec252;
      font-weight: 500;
    }
  }
`;
